import { api } from "api";

export interface LoginResponse {
  contact: string;
  firstName: string;
  lastName: string;
  refreshToken: string;
  accessToken: string;
  networkCode: string;
  hasError?: boolean;
  isInternal?: boolean;
}

export interface ProfileResponse {
  contact: string;
  firstName: string;
  lastName: string;
}

export const loginRequest = ({
  code,
  language,
  isInternal,
}: {
  code: string;
  language: string;
  isInternal: boolean;
}) => {
  return api.post<{ redirectUrl: string }>("account/login", null, {
    params: { culture: language, code, isInternal },
  });
};

export const loginWithCodeRequest = ({
  code,
  state,
}: {
  code: string;
  state: string;
}) => {
  return api.post<LoginResponse>(
    "account/loginCode",
    { Code: code, State: state },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const getProfileRequest = (networkId?: number) => {
  return api.get<ProfileResponse>(`Account/Profile/${networkId}`);
};
